export default "__VITE_ASSET__166e1fad__"